import type { Locale } from "@/lib/i18n";
import { pl, type WCallTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wCallTranslations: Record<Locale, WCallTranslations> = {
  pl,
  en,
  de,
};

export type { WCallTranslations };
